export default
    class Promotion {
    constructor(
        name = '', sub_title = '', description = '', url_img = '', expiry_time = null,
        usage_time = 0, type = 'package', start_date = '', max_free_km = null,
        end_date = '', promotionClients = [], promotionVehicleModels = [],order = 1,
        valid_days = {
            segunda: true,
            terca: true,
            quarta: true,
            quinta: true,
            sexta: true,
            sabado: true,
            domingo: true
        },
    ) {
        this.name = name
        this.sub_title = sub_title
        this.description = description
        this.url_img = url_img
        this.usage_time = usage_time
        this.valid_days = valid_days
        this.type = type
        this.start_date = start_date
        this.end_date = end_date
        this.promotionClients = promotionClients
        this.promotionVehicleModels = promotionVehicleModels
        this.expiry_time = expiry_time
        this.max_free_km = max_free_km
        this.vehicles_model_category = 1
        this.order = order
    }
}
